import React, { useMemo } from "react";

import motiviert1 from "../../assets/ace/motiviert1.png";
import motiviert2 from "../../assets/ace/motiviert2.png";
import ruhig1 from "../../assets/ace/ruhig1.png";
import ruhig2 from "../../assets/ace/ruhig2.png";
import stress1 from "../../assets/ace/stress1.png";
import stress2 from "../../assets/ace/stress2.png";

export default function AceAvatar({
  mood = "motiviert",
  variant = 1,
  size = 44,
  className = "",
  alt = "Ace",
}) {
  const src = useMemo(() => {
    // Unterstützt jetzt BEIDES:
    // 1) mood="ruhig" variant={2}
    // 2) variant="ruhig2"

    if (typeof variant === "string") {
      const key = variant.toLowerCase();
      if (key === "motiviert1") return motiviert1;
      if (key === "motiviert2") return motiviert2;
      if (key === "ruhig1") return ruhig1;
      if (key === "ruhig2") return ruhig2;
      if (key === "stress1") return stress1;
      if (key === "stress2") return stress2;
    }

    const v = Number(variant) === 2 ? 2 : 1;

    if (mood === "ruhig") return v === 2 ? ruhig2 : ruhig1;
    if (mood === "gestresst") return v === 2 ? stress2 : stress1;

    return v === 2 ? motiviert2 : motiviert1;
  }, [mood, variant]);

  return (
    <img
      src={src}
      alt={alt}
      className={`select-none ${className}`}
      style={{ width: size, height: size, objectFit: "contain" }}
      draggable={false}
    />
  );
}